import { render, staticRenderFns } from "./pop-modal.vue?vue&type=template&id=2770e20c&lang=pug&"
import script from "./pop-modal.vue?vue&type=script&lang=js&"
export * from "./pop-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports